import { getUserLabel } from '@iconik-io/core/src/get_user_label';
import { httpGetUsersBasic } from '@iconik-io/iconik-api/src/services/users';

import type { AppDispatch } from '../../store/types';
import { prepareQueryParameter } from '../search_utils/search_utils';

export type UserOption = {
  id: string;
  label: string;
  email?: string;
};

export async function fetchUsersByQuery(
  userQuery: string,
  dispatch: AppDispatch,
): Promise<UserOption[]> {
  const response = await dispatch(
    httpGetUsersBasic({
      query: prepareQueryParameter(userQuery),
      sort: 'first_name,asc',
      per_page: 50,
    }),
  );

  const users: UserOption[] = [];
  for (const user of response.body.objects) {
    users.push({
      id: user.id,
      label: getUserLabel(user),
      email: user.email ?? undefined,
    });
  }
  return users;
}
